import { render } from "./DynamicBlogDetails.vue?vue&type=template&id=b4be1ec6&scoped=true"
import script from "./DynamicBlogDetails.vue?vue&type=script&lang=js"
export * from "./DynamicBlogDetails.vue?vue&type=script&lang=js"

import "./DynamicBlogDetails.vue?vue&type=style&index=0&id=b4be1ec6&scoped=true&lang=css"

import exportComponent from "/Users/frknalck/Desktop/GelisimPTurkiye/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4be1ec6"]])

export default __exports__